import './intro.scss';

export default () => {
	const shareButton = document.getElementById( 'intro-shareButton' );

	if ( shareButton ) {
		shareButton.addEventListener( 'click', async ( event ) => {
			event.preventDefault();

			if ( navigator.share ) {
				try {
					await navigator.share( {
						title: document.title,
						text: 'Bekijk deze vacature, wellicht iets voor jou!',
						url: window.location.href,
					} );
					console.error( 'Vacature succesvol gedeeld' );
				} catch ( error ) {
					console.error( 'Fout bij delen:', error );
				}
			} else {
				alert( `Delen wordt niet ondersteund in deze browser. Kopieer de URL: ${window.location.href}` );
			}
		} );
	}
};
